export {SearchResultsRendererConnected as SearchResultsRenderer} from './SearchResultsRenderer.connect';
